import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels, useRequestData } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import {
	HighlightedAttribute,
	getFuelTypeIconAndPopoverLabel,
	LocationPopoverContent,
	isValidFuelType
} from 'wsm-highlighted-attribute';

const HighlightedAttributeContainer = ({ accountInfo, isGridLayout }) => {
	const {
		enableLocationHighlight,
		enableFuelTypeHighlight,
		highlightedFuelTypeElectricIcon,
		highlightedFuelTypeHybridIcon
	} = usePrefs();
	const labels = useLabels();
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';
	const isEnabled =
		enableLocationHighlight === 'true' ||
		enableFuelTypeHighlight === 'true';

	let fuelTypeAttribute;
	if (
		enableFuelTypeHighlight === 'true' &&
		isValidFuelType(accountInfo.fuelType)
	) {
		const [fuelTypeIcon, fuelTypePopover] = getFuelTypeIconAndPopoverLabel({
			fuelType: accountInfo.fuelType,
			electricIcon: highlightedFuelTypeElectricIcon,
			hybridIcon: highlightedFuelTypeHybridIcon,
			labels
		});

		fuelTypeAttribute = (
			<HighlightedAttribute
				icon={fuelTypeIcon}
				popoverContent={fuelTypePopover}
				type="fuelType"
				chipClasses={[
					accountInfo.fuelType.toLowerCase(),
					'mr-3',
					isGridLayout ? 'mb-3' : ''
				]}
			>
				{accountInfo.fuelType}
			</HighlightedAttribute>
		);
	}

	let locationAttribute;
	if (enableLocationHighlight === 'true' && accountInfo.name) {
		const cleanTitle = window?._?.unescape(accountInfo.name);
		const popoverAria = `${labels.get(
			'THIS_VEHICLE_IS_LOCATED_AT'
		)} ${cleanTitle}`;
		let popoverContent;
		if (
			Object.keys(accountInfo.address).length !== 0 ||
			accountInfo.phone
		) {
			popoverContent = (
				<LocationPopoverContent
					phone={accountInfo.phone}
					id={accountInfo.id}
					address={accountInfo.address}
					isMobile={isMobile}
				/>
			);
		}
		locationAttribute = (
			<HighlightedAttribute
				icon="ddc-icon-map"
				popoverContent={popoverContent}
				type="location"
				chipClasses={['location', 'mr-3', isGridLayout ? 'mb-3' : '']}
				popoverAria={popoverAria}
			>
				{cleanTitle}
			</HighlightedAttribute>
		);
	}

	if (isEnabled) {
		return (
			<div
				className={setClassNames([
					'vehicle-card-highlight',
					'mb-3',
					'align-self-start',
					'd-flex',
					'flex-wrap'
				])}
			>
				{locationAttribute}
				{fuelTypeAttribute}
			</div>
		);
	}
	return null;
};

HighlightedAttributeContainer.propTypes = {
	accountInfo: PropTypes.shape({
		name: PropTypes.string,
		address: PropTypes.shape({}),
		phone: PropTypes.string,
		id: PropTypes.string,
		fuelType: PropTypes.string
	}).isRequired,
	isGridLayout: PropTypes.bool.isRequired
};

export default HighlightedAttributeContainer;
